import React from 'react';
import { Link } from 'react-router-dom';
import { BOOK, BOOKS } from '../../utils/constants';
import './itemDetailsView.css';
import { string, func, object, element, array, oneOfType, node } from 'prop-types';
import Image from '../UI/image';

const ItemDetailsView = ({ name, item, extractItemName, itemType, children, imgUrl }) => (
  <>
    <div className="item-details rounded">
      <h4>{name}</h4>

      {(extractItemName(itemType) === BOOK && imgUrl) &&
        (<Image
          className='item-details img'
          src={imgUrl}
          alt={name}
        />)}

      <ul className="list-group list-group-flush">
        {React.Children.map(children, child => {
          return React.cloneElement(child, { item })
        })}
      </ul>
    </div>
    {extractItemName(itemType) === BOOK &&
      (<Link to={`/${BOOKS}/`} className='btn btn-primary book-details-redirect'>Go back to books list</Link>)
    }
  </>
)

ItemDetailsView.propTypes = {
  name: string,
  extractItemName: func,
  item: object,
  imgUrl: string,
  itemType: string,
  children: oneOfType([array, element, node]),
}

ItemDetailsView.defaultProps = {
  name: '',
  extractItemName: () => { },
  item: {},
  imgUrl: '',
  itemType: '',
  children: null,
}

export default ItemDetailsView